<ng-template #singleImage let-field="field" let-fieldPath="fieldPath" let-translation="translation">
  <mat-card appearance="outlined" class="images-container">
    <h2>{{ translation | translate }}</h2>
    <div class="main-actions">
      <button (click)="chooseFromMediaAssets(fieldPath)" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.chooseImage' | translate }}</button>
    </div>
    <div class="table-header">
      <div class="preview"></div>
      <div class="title">{{'general.title' | translate}}</div>
      <div class="date">{{ 'general.created' | translate }}</div>
      <div class="size">{{'general.size' | translate}}</div>
      <div class="actions"></div>
    </div>

    <div class="table">
      <div class="table-row" *ngIf="!!myPackage.screen[field]">
        <div class="preview" (mouseenter)="hover(myPackage.screen[field], $event)" (mouseleave)="leave()">
          <img  [src]="myPackage.screen[field]" />
        </div>
        <div class="title">{{ getAsset(myPackage.screen[field])?.title }}</div>
        <div class="date">
          <ng-container *ngIf="getAsset(myPackage.screen[field])?.created">{{ getAsset(myPackage.screen[field]).created | date:'dd.MM.YYYY' }}</ng-container>
        </div>
        <div class="size">
          <ng-container *ngIf="getAsset(myPackage.screen[field])?.fileSize">{{ getAsset(myPackage.screen[field]).fileSize | fileSize }}</ng-container>
        </div>
        <div class="actions">
          <button class="ibexfusion-icon-button" mat-icon-button (click)="chooseFromMediaAssets(fieldPath)"><mat-icon>edit</mat-icon></button>
          <button class="ibexfusion-icon-button" mat-icon-button (click)="myPackage.screen[field] = null"><mat-icon>delete</mat-icon></button>
        </div>
      </div>
    </div>
  </mat-card>
</ng-template>

<ng-template #multipleImages let-field="field" let-fieldPath="fieldPath" let-translation="translation" let-type="type" let-suffix="suffix">
  <mat-card appearance="outlined" class="images-container">
    <h2>{{ translation | translate }}</h2>
    <div class="main-actions">
      <button (click)="addImage(type, fieldPath, suffix)" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.chooseImage' | translate }}</button>
      <button (click)="addVideo(type, suffix)" class="ibexfusion-raised-button small" mat-button>{{ 'dynamicContent.chooseVideo' | translate }}</button>
    </div>
    <div class="table-header">
      <div class="preview"></div>
      <div class="title">{{'general.title' | translate}}</div>
      <div class="drag">
        <mat-icon>keyboard_arrow_up</mat-icon>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </div>
      <div class="active">{{'general.active' | translate}}</div>
      <div class="publishing">{{ 'general.publishingImage' | translate }}</div>
      <div class="date">{{ 'general.created' | translate }}</div>
      <div class="size">{{'general.size' | translate}}</div>
      <div class="actions"></div>
    </div>

    <div class="table" (cdkDropListDropped)="dropImage($event, field)" cdkDropList>
      <div *ngFor="let image of myPackage.screen[field], let i = index" class="table-row" cdkDrag cdkDragBoundary=".menu-item-list">
        <div *cdkDragPlaceholder class="drag-placeholder"></div>
        <div class="preview" (mouseenter)="hover(image['url' + (!!suffix ? suffix : '')], $event)" (mouseleave)="leave()">
          <img *ngIf="image.type !== 'video'" [src]="image['url' + (!!suffix ? suffix : '')]" />
          <video *ngIf="image.type === 'video'" [src]="image['url' + (!!suffix ? suffix : '')]"></video>
        </div>
        <div class="title">{{ getAsset(image['url' + (!!suffix ? suffix : '')])?.title }}</div>
        <div class="drag">
          <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
            <mat-icon>drag_indicator</mat-icon>
          </button>
        </div>
        <div class="active">
          <ibex-checkbox [checked]="!myPackage.screen[field][i]?.disabled" (click)="setDisabled(field, i)"></ibex-checkbox>
        </div>
        <div class="publishing">
          <smart-input [hideDescription]="true" (onChange)="setActiveImage(type)" [(model)]="myPackage" [jsonPointerKey]="fieldPath + '/' + i" format="dd-mm" key="from"></smart-input>
          <smart-input [hideDescription]="true" (onChange)="setActiveImage(type)" [(model)]="myPackage" [jsonPointerKey]="fieldPath + '/' + i" format="dd-mm" key="to"></smart-input>
        </div>
        <div class="date">
          <ng-container *ngIf="getAsset(image['url' + (!!suffix ? suffix : '')])?.created">{{ getAsset(image['url' + (!!suffix ? suffix : '')]).created | date:'dd.MM.YYYY' }}</ng-container>
        </div>
        <div class="size">
          <ng-container *ngIf="getAsset(image['url' + (!!suffix ? suffix : '')])?.fileSize">{{ getAsset(image['url' + (!!suffix ? suffix : '')]).fileSize | fileSize }}</ng-container>
        </div>
        <div class="actions">
          <button class="ibexfusion-icon-button" mat-icon-button (click)="editMedia(getAsset(image['url' + (!!suffix ? suffix : '')]))"><mat-icon>edit</mat-icon></button>
          <button class="ibexfusion-icon-button" mat-icon-button (click)="removeImage(type, i)"><mat-icon>delete</mat-icon></button>
        </div>
      </div>
    </div>
  </mat-card>
</ng-template>
<page-toolbar [pageActions]="pageActions" title="{{'pages.images' | translate}}" *ngIf="!noHeader"></page-toolbar>
<page-content [noPadding]="true" *ngIf="myPackage">
  <div class="menu-buttons">
    <div class="menu-button" *ngFor="let navigation of navigationPoints" (click)="activeNavigation = navigation" [ngClass]="{ active: navigation === activeNavigation }">
      {{ navigation }}
    </div>
  </div>
  <div class="images">
    <ng-container *ngIf="activeNavigation === 'ibextouch'">
      <ng-container *ngTemplateOutlet="singleImage;context:{ field: 'screenLogo', fieldPath: '/screen/screenLogo', translation: 'packages.images.logoLayer' }"></ng-container>
      <ng-container *ngTemplateOutlet="multipleImages;context:{ field: 'screenImages', fieldPath: '/screen/screenImages', translation: 'packages.screen.backgroundImages', type: 'screen', suffix: 'Home' }"></ng-container>
    </ng-container>
    <ng-container *ngIf="activeNavigation === 'ibextv'">
      <ng-container *ngTemplateOutlet="singleImage;context:{ field: 'tvLogo', fieldPath: '/screen/tvLogo', translation: 'packages.images.logoLayer' }"></ng-container>
      <ng-container *ngTemplateOutlet="multipleImages;context:{ field: 'tvImages', fieldPath: '/screen/tvImages', translation: 'packages.screen.backgroundImages', type: 'tv' }"></ng-container>
    </ng-container>
    <ng-container *ngIf="activeNavigation === 'ibexsmart'">
      <ng-container *ngTemplateOutlet="singleImage;context:{ field: 'mobileLogo', fieldPath: '/screen/mobileLogo', translation: 'packages.images.logoMobile' }"></ng-container>
      <ng-container *ngTemplateOutlet="singleImage;context:{ field: 'favicon', fieldPath: '/screen/favicon', translation: 'packages.images.favicon' }"></ng-container>
      <ng-container *ngTemplateOutlet="multipleImages;context:{ field: 'emoImages', fieldPath: '/screen/emoImages', translation: 'packages.screen.mobileImages', type: 'emo' }"></ng-container>
    </ng-container>
    <ng-container *ngIf="activeNavigation === 'ibextablet'">
      <div *ngIf="!myPackage.screen['tabletLogo'] && (!myPackage.screen['tabletImages'] || !myPackage.screen['tabletImages'].length)" class="empty-logo-msg">
        Es wurde noch kein Hintergrundbild und/oder Logo erfasst.<br>
        Klicken Sie <span (click)="chooseFromMediaAssets('tabletLogo')">hier</span> oder auf den Plus-Button, um ein erstes Bild zu erfassen.
        <br><br>Wird kein Bild erfasst, werden die ibextouch-Einstellungen übernommen.
      </div>
      <ng-container *ngTemplateOutlet="singleImage;context:{ field: 'tabletLogo', fieldPath: '/screen/tabletLogo', translation: 'packages.images.logoLayerTablet' }"></ng-container>
      <ng-container *ngTemplateOutlet="multipleImages;context:{ field: 'tabletImages', fieldPath: '/screen/tabletImages', translation: 'packages.screen.backgroundImages', type: 'tablet' }"></ng-container>
    </ng-container>
    <div class="button-right-container">
      <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
    </div>
  </div>
</page-content>
